export const getGoalStrategies = (state) => {
  return state.goalStrategy.items;
};

export const getTargetGoalStrategy = (state) => {
  return state.goalStrategy.target;
};
